module.exports = __webpack_public_path__ + "static/media/cat-cow-pose.ec06f48b.mp4";